export class BibleReadDayChapter {
     Title: string;
     Chapter: string;
}
